import React, { 
  //useState, useEffect 
  } 
  from 'react';
import { Dropdown, OverlayTrigger, Tooltip, TooltipProps, Badge } from 'react-bootstrap';
// import { useDispatch } from 'react-redux';
// import * as actions from '../../../../Redux/Actions';
import "./RewardsListDropdown.scss";
import { Award } from '../Awards/rnr.types';

interface RewardsListDropdownProps {
  onAwardSelect: (award: Award) => void;
  selectedAward: Award | null;
  unavailableAwardIds?: string[];
  ineligibleAwardIds?: string[];
  awards: (Award & { isEligible?: boolean })[]; 
}

const IneligibleTooltip = (props: TooltipProps) => (
  <Tooltip id="ineligible-tooltip" {...props}>
    Employee does not meet the criteria to receive this award.
  </Tooltip>
);

const AwardTooltip = ({ award, ...props }: { award: Award } & TooltipProps) => (
  <Tooltip id={`tooltip-${award._id}`} {...props}>
    <div style={{ textAlign: 'left' }}>
      <p style={{ marginBottom: '5px' }}>
        <strong>Frequency:</strong> {award.nominationWindow?.frequency}
      </p>
      <p style={{ margin: 0 }}>
        <strong>Definition:</strong> {award.definition}
      </p>
      {award.nominationWindowStatus?.status && (
        <p style={{ margin: 0 }}>
          <strong>Status:</strong> {award.nominationWindowStatus.label || award.nominationWindowStatus.status}
        </p>
      )}
    </div>
  </Tooltip>
);

const getStatusVariant = (status?: string) => {
  switch (status) {
    case 'Open':
    case 'Always Open':
      return 'success';
    case 'Upcoming':
      return 'warning';
    case 'Closed':
      return 'danger';
    default:
      return 'dark';
  }
};

const RewardsListDropdown = ({ onAwardSelect, selectedAward, unavailableAwardIds = [], awards = [] }: RewardsListDropdownProps) => {
  //const dispatch = useDispatch();
  //const [awards, setAwards] = useState<Award[] | null>([]);
  //const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   dispatch(actions.listAwardsAction((res: { success: boolean; data: Award[]; error?: any }) => {
  //     setLoading(false);
  //     if (!res.success) {
  //       console.error("Failed to fetch awards list:", res.error);
  //     } else {
  //       setAwards(res?.data);
  //     }
  //   }));
  // }, [dispatch]);

  const handleOptionSelect = (award: Award) => {
    onAwardSelect(award);
  };

  return (
    <Dropdown>
      <Dropdown.Toggle id="dropdown-awards">
        {
          selectedAward 
            ? <span className='text-truncate'>{selectedAward.awardCategory}</span>
            : 'Select Award'
        }
      </Dropdown.Toggle>

      <Dropdown.Menu 
        style={{ 
          height: '300px',
          maxHeight: '450px', 
          width: '200%', 
          maxWidth: '400px', 
          flexWrap: 'wrap', 
          overflowY: 'auto' 
        }}
      >
        <Dropdown.Divider />
        {awards && awards.map((award) => {
          const status = award.nominationWindowStatus?.status;
          // const isDisabled = 
          //   unavailableAwardIds.includes(award._id) ||
          //   status === 'Closed' ||
          //   status === 'Upcoming';

          const isPreviouslyNominated = unavailableAwardIds.includes(award._id);
          const isWindowClosed = status === 'Closed' || status === 'Upcoming';
          const isEmployeeIneligible = !award.isEligible; 
          
          const isDisabled = isPreviouslyNominated || isEmployeeIneligible || isWindowClosed;

          const tooltipToDisplay = isEmployeeIneligible 
            ? <IneligibleTooltip /> 
            : <AwardTooltip award={award} />;

          const dropdownItem = (
            <Dropdown.Item
              onClick={() => !isDisabled && handleOptionSelect(award)}
              disabled={isDisabled}
              active={selectedAward?._id === award._id}
              className={`
                dropdown-item-wrap d-flex justify-content-between align-items-center
                ${isEmployeeIneligible ? 'ineligible-award' : ''}
              `}
            >
              <span>{award.awardCategory}</span>
              {status && (
                <Badge bg={getStatusVariant(status)} pill>
                  {status}
                </Badge>
              )}
            </Dropdown.Item>
          );
          
          return (
            <OverlayTrigger
              key={award._id}
              placement="auto"
              delay={{ show: 250, hide: 4000 }}
              overlay={tooltipToDisplay}
              container={document.body}
            >
              <span className="d-block">
                {dropdownItem}
              </span>
            </OverlayTrigger>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default RewardsListDropdown;
